export const toCapitalize = (str: string): string => {
  const capitalized = str.toLowerCase().charAt(0).toUpperCase() + str.slice(1);
  return capitalized;
};
